import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, tap } from 'rxjs';
import { environment } from '../../environments/environment';
import { LocalStorageKeys } from '../shared/models/user';
import { Router } from '@angular/router';
import { AppConfig } from '../utils/app-config';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  exp: any;
  private baseUrl = AppConfig.getConfig().api_url;
  constructor(
    private httpClient: HttpClient,
    private router: Router,
  ) {
  }
  login(body: any) {
    return this.httpClient.post(`${this.baseUrl}auth/login/`, body).pipe(
      tap((response: any) => response)
    );
  }
  forgotPassword(body: any){
    return this.httpClient.post(`${this.baseUrl}auth/forgot-password/`, body).pipe(
      tap((response: any) => response)
    );
  }
  resetPassword(id:any,token:any,body: any){
    return this.httpClient.post(`${this.baseUrl}auth/reset-password/${id}/${token}/`, body).pipe(
      tap((response: any) => response)
    );
  }
  onSamlLogin(body: any){
    return this.httpClient.post(`${this.baseUrl}auth/login/saml/`, body).pipe(
      tap((response: any) => response)
    );
  }
  onSendContactForm(body: any){
    return this.httpClient.post(`${this.baseUrl}auth/contact/us/`, body).pipe(
      tap((response: any) => response)
    );
  }
  changePassword(body: any){
    return this.httpClient.put(`${this.baseUrl}auth/change-password/`, body).pipe(
      tap((response: any) => response)
    );
  }
  logout() {
    return this.httpClient.post(`${this.baseUrl}auth/logout/`, '').pipe(
      tap((response: any) => response)
    );
  }

  disconnectFacebook(body:any){
    return this.httpClient.post(`${this.baseUrl}disconnect/facebook/`, body).pipe(
      tap((response: any) => response)
    );
  }

  disconnectLinkedIn(body:any){
    return this.httpClient.post(`${this.baseUrl}disconnect/linkedin/`, body).pipe(
      tap((response: any) => response)
    );
  }

  disconnectInsta(body:any){
    return this.httpClient.post(`${this.baseUrl}disconnect/instagram/`, body).pipe(
      tap((response: any) => response)
    );
  }

  disconnectTwitter(body:any){
    return this.httpClient.post(`${this.baseUrl}disconnect/twitter/`, body).pipe(
      tap((response: any) => response)
    );
  }

  getTokenValue(body:any){
    return this.httpClient.post(`${this.baseUrl}auth/action/token/`, body).pipe(
      tap((response: any) => response)
    );
  }

  clearLocalStorage(){
    const remember = window.localStorage.getItem(LocalStorageKeys.RememberMe);
    const user1 = window.localStorage.getItem(LocalStorageKeys.Email);
    const pass = window.localStorage.getItem(LocalStorageKeys.Password);
    window.localStorage.clear();
    if(remember == 'true'){
      window.localStorage.setItem(LocalStorageKeys.Email, `${user1}`);
      window.localStorage.setItem(LocalStorageKeys.Password, `${pass}`);
      window.localStorage.setItem(LocalStorageKeys.RememberMe, `${remember}`);
    }
    else{
      window.localStorage.clear();
    }
    setTimeout(() => {
        this.router.navigate(['/auth/login']);
    }, 600);
  }

  /***
  * super-admin
  */
  isSuperAdmin() {
    let role = window.localStorage.getItem(LocalStorageKeys.Role);
    if(role === 'Super Admin'){
      return true
    }
    else{
      return false;
    }
  }

  /***
  * company-admin
  */
  isCompanyAdmin() {
    let role = window.localStorage.getItem(LocalStorageKeys.Role);
    if(role === 'Company'){
      return true
    }
    else{
      return false;
    }
  }

  /***
  * Employee
  */
  isEmployee() {
    let role = window.localStorage.getItem(LocalStorageKeys.Role);
    if(role === 'Employee'){
      return true
    }
    else{
      return false;
    }
  }
}
